import PubSub from 'pubsub-js';

class OTEventManager {
  static RECONNECT_EVENT = 'reconnect';

  static RESTART_EVENT = 'restart';

  constructor() {
    this.observer = PubSub;
    this.reconnectTokens = [];
    this.restartTokens = [];
  }

  /** Reconnect methods */
  emitReconnect() {
    this.observer.publish(OTEventManager.RECONNECT_EVENT);
  }

  onReconnect(cb) {
    const token = this.observer.subscribe(OTEventManager.RECONNECT_EVENT, () =>
      cb(),
    );
    this.reconnectTokens.push(token);
    return () => {
      this.reconnectTokens = this.reconnectTokens.filter(t => t !== token);
      return this.observer.unsubscribe(token);
    };
  }

  offReconnect() {
    this.reconnectTokens.forEach(token => this.observer.unsubscribe(token));
    this.reconnectTokens = [];
  }

  /** Restart methods */
  emitRestart() {
    this.observer.publish(OTEventManager.RESTART_EVENT);
  }

  onRestart(cb) {
    const token = this.observer.subscribe(OTEventManager.RESTART_EVENT, () =>
      cb(),
    );
    this.restartTokens.push(token);
    return () => {
      this.restartTokens = this.restartTokens.filter(t => t !== token);
      return this.observer.unsubscribe(token);
    };
  }

  offRestart() {
    this.restartTokens.forEach(token => this.observer.unsubscribe(token));
    this.restartTokens = [];
  }
}

export const otEventManager = new OTEventManager();



// WEBPACK FOOTER //
// ./src/redux/opentok/helpers/eventManager.js